import { Fragment } from "react";
import { H4, Image, LI, P } from "../../../../AbstractElements";
import { VARIATION_TIMELINE_DATA } from "../../../../Data/Bonus Ui/Timeline";

export const DynamicVariationTimeline = () => {
  return (
    <Fragment>
      {VARIATION_TIMELINE_DATA.map((data, index) => (
        <LI className={`d-flex mb-2 ${data.className}`} key={index}>
          <div className={`activity-dot-${data.color}`}></div>
          <div className="w-100 ms-3">
            <P className="d-flex justify-content-between mb-2">
              <span className="date-content light-background">{data.date}</span>
              <span>{data.time}</span>
            </P>
            <H4 className="f-w-700">
              {data.title}
              <span className="dot-notification"></span>
            </H4>
            <span className={data.subTitleClass ? data.subTitleClass : ""}>{data.subTitle}</span>
            {data.image && (
              <div className="recent-images mb-2">
                <ul>
                  {data.image.map((item, index) => (
                    <li key={index}>
                      <div className="recent-img-wrap">
                        <Image src={item} className="me-0" alt="chair" />
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </LI>
      ))}
    </Fragment>
  );
};
